import React from 'react';
import { NavLink, useMatch } from 'react-router-dom';
import type { AppStatus } from '../types';
import ScopeSelector from './ScopeSelector';
import StatusBar from './StatusBar';

interface SidebarProps {
  status: AppStatus;
}

const linkStyle = (active: boolean): React.CSSProperties => ({
  textAlign: 'left',
  marginTop: 6,
  background: active ? '#e3f2fd' : undefined,
  textDecoration: 'none',
  display: 'block',
});

const Sidebar: React.FC<SidebarProps> = ({ status }) => {
  const seedsActive = useMatch('/seeds/*') !== null;
  const batchesActive = useMatch('/batches/*') !== null;

  return (
    <aside
      style={{
        width: 240,
        minWidth: 240,
        maxWidth: 260,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        padding: 16,
        boxSizing: 'border-box',
        background: '#ffffff',
        borderRight: '1px solid #e0e0e0',
      }}
    >
      <h1 style={{ fontSize: 18, fontWeight: 600, margin: 0 }}>Self-Play Manager</h1>
      <ScopeSelector />
      <div style={{ marginTop: 12, fontSize: 11, textTransform: 'uppercase', color: '#888' }}>Main</div>
      <NavLink to="/seeds" className="button" style={linkStyle(seedsActive)}>
        Seeds
      </NavLink>
      <NavLink to="/batches" className="button" style={linkStyle(batchesActive)}>
        Batches
      </NavLink>
      <div style={{ marginTop: 14, fontSize: 11, textTransform: 'uppercase', color: '#888' }}>Configuration</div>
      <NavLink to="/tags" className="button" style={({ isActive }) => linkStyle(isActive)}>
        Tags
      </NavLink>
      <div style={{ marginTop: 'auto' }}>
        <StatusBar status={status} />
      </div>
    </aside>
  );
};

export default Sidebar;
